import { useSelector } from 'react-redux';
import { selectCurrentClient } from '../CommonSelectors/CommonAreaSelector';

export const useClientId = () => {
  const { Id: clientId } = useSelector(selectCurrentClient);

  return clientId;
};
